import module from './module.js'
// Components
import './components/conceptos/component.js'
import './components/conceptos/editar/component.js'
import './components/conceptos/editar/impuestos/component.js'
import './components/conceptos/editar/impuestos/agregar/component.js'
import './components/conceptos/editar/impuestos/item/component.js'
import './components/conceptos/editar/impuestos/eliminar/component.js'
import './components/conceptos/editar/productosservicios/component.js'
import './components/conceptos/editar/productosservicios/item/component.js'
import './components/conceptos/editar/unidadesmedida/component.js'
import './components/conceptos/editar/unidadesmedida/item/component.js'
import './components/conceptos/lista/component.js'
import './components/conceptos/lista/item/component.js'
import './components/conceptos/lista/item/eliminar/component.js'
// Services
import './services/Configuracion/Concepto.js'
import './services/Configuracion/Conceptos.js'
import './services/Configuracion/Conceptos/TipoComprobante.js'
// Routes
import './routes/configuracion.js'
import './routes/configuracion/conceptos.js'
import './routes/configuracion/conceptos/agregar.js'
import './routes/configuracion/conceptos/editar.js'

export default module.name



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/index.js